import { Comment as ApiComment } from '@api/feeds/interfaces';
import { Comment } from '../Feed/components/CommentsSection/interfaces';

export const mapApiComments = (comments: ApiComment[]): Comment[] => {
  return comments.map((apiComment) => ({
    id: apiComment.id,
    content: apiComment.body,
    date: new Date(apiComment.createdAt),
    author: {
      name: apiComment.author.fullName,
      slug: apiComment.author.slug,
    },
    likesCount: apiComment.likesCount ?? 0,
    likedByCurrentUser: apiComment.likedByCurrentUser ?? false,
  }));
};
